/**
 * tio-api plan eligibility conditions (mirrors Plan::ELIGIBILITY_CONDITIONS)
 * that indicate an SLR loan-standing verification requirement. A plan carrying
 * any of these requires the employee to periodically prove their loans are in
 * good standing.
 */
export const SLR_LOAN_STANDING_ELIGIBILITY_CONDITIONS = [
  'require_document',
  'require_recent_document',
  'require_audit_window_upload',
  'allow_late_requalification',
  'require_name_match',
  'require_required_observations',
  'require_good_standing_status',
  'reject_parent_plus_only',
] as const;

const KNOWN_CONDITIONS = new Set<string>(SLR_LOAN_STANDING_ELIGIBILITY_CONDITIONS);

/**
 * Whether a plan requires SLR loan-standing verification, derived from its
 * `eligibility_conditions`. This is the source of truth for the feature being
 * "enabled" for a plan — tio-api does not send a dedicated `featureEnabled`
 * flag. Wiring this into the dashboard alert gating (replacing the imagined
 * `state.featureEnabled`) is tracked in tio-front-end#8714.
 */
export function planRequiresLoanStandingVerification(
  eligibilityConditions?: readonly string[] | null
): boolean {
  if (!eligibilityConditions) return false;
  return eligibilityConditions.some((condition) => KNOWN_CONDITIONS.has(condition));
}
